import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/academy/internal`;
const authHeader = () => {
  const t = localStorage.getItem('dermascan_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const academyInternalApi = {
  async fullContent(trainingId) {
    const { data } = await axios.get(`${BASE}/trainings/${trainingId}/full-content`, {
      headers: authHeader(),
    });
    return data;
  },
  async submitQuiz(enrollmentId, answers) {
    const { data } = await axios.post(
      `${BASE}/enrollments/${enrollmentId}/quiz-attempt`,
      { answers },
      { headers: authHeader() },
    );
    return data;
  },
  async submitPracticalEval(enrollmentId, scores, comment) {
    const { data } = await axios.post(
      `${BASE}/enrollments/${enrollmentId}/practical-eval`,
      { scores, comment: comment || '' },
      { headers: authHeader() },
    );
    return data;
  },
  async certificateData(enrollmentId) {
    const { data } = await axios.get(`${BASE}/enrollments/${enrollmentId}/certificate-data`, {
      headers: authHeader(),
    });
    return data;
  },
};
